var React = require('react');

function PlayLg (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("title",{"key":1},"Asset 6300ppi"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":2},React.createElement("g",{"id":"play"},React.createElement("path",{"className":"media-control-lg","d":"M155.71,85.8a18.27,18.27,0,0,1-.47,30.32l-65.4,39.47L24.51,195.13a16.24,16.24,0,0,1-24-15.57l-.12-81L0,17.08A16.18,16.18,0,0,1,24.53,2.32l67.14,42Z"})))]);
}

PlayLg.defaultProps = {"width":"35px","height":"35px","viewBox":"0 0 163.55 197.15"};

module.exports = PlayLg;

PlayLg.default = PlayLg;
